// widerstandStation.js (neu mit vollem Drag & Drop + Touch Support)

export default function showWiderstandPopup() {
    const popup = document.getElementById('widerstand-popup');
    if (!popup || !popup.classList.contains('hidden')) return;
  
    popup.classList.remove('hidden');
  
    const words     = popup.querySelectorAll('.word');
    const dropZones = popup.querySelectorAll('.drop-zone');
    const checkBtn  = popup.querySelector('.check-button');
    const nextBtn   = popup.querySelector('.next-button');
    const backBtn   = popup.querySelector('.back-button');
    const closeBtns = popup.querySelectorAll('.close-popup, .close-popup-btn');
  
    let draggedText = null;
  
    // Drag mit Maus
    words.forEach((word, idx) => {
      word.id = `word-${idx}`;
      word.addEventListener('dragstart', (e) => {
        draggedText = e.target.innerText;
        e.dataTransfer.setData('text/plain', draggedText);
      });
    });
  
    // Touch (Tap–Tap)
    words.forEach(word => {
      word.addEventListener('touchstart', (e) => {
        e.preventDefault(); // iOS Safari: verhindert Selektion/Scroll
        draggedText = word.innerText;
        word.classList.add('dragging');
      });
      word.addEventListener('touchend', () => {
        word.classList.remove('dragging');
      });
    });
  
    // Drop-Zonen (Maus + Touch)
    dropZones.forEach(zone => {
      zone.addEventListener('dragover', (e) => {
        e.preventDefault();
        zone.style.background = '#e0f7fa';
      });
      zone.addEventListener('dragleave', () => {
        zone.style.background = 'white';
      });
      zone.addEventListener('drop', (e) => {
        e.preventDefault();
        const text = e.dataTransfer.getData('text/plain');
        if (!text) return;
        const wordEl = Array.from(popup.querySelectorAll('.word'))
          .find(el => el.innerText === text);
        if (wordEl) zone.appendChild(wordEl);
        zone.style.background = 'white';
      });
      zone.addEventListener('touchmove', (e) => e.preventDefault());
      zone.addEventListener('touchend', () => {
        if (!draggedText) return;
        const wordEl = Array.from(popup.querySelectorAll('.word'))
          .find(el => el.innerText === draggedText);
        if (wordEl) zone.appendChild(wordEl);
        draggedText = null;
        zone.style.background = 'white';
      });
    });
  
    // Check Button
    checkBtn?.addEventListener('click', () => {
      const correctAssignments = {
        'kognition': ['Notwendigkeit der Veränderung?', 'Unverständnis', 'Abwertung'],
        'affekt': ['Angst', 'Wut', 'Nervosität'],
        'verhalten': ['Beschwerden', 'Gerüchte streuen', 'Verweigerung']
      };
  
      let allCorrect = true;
      const feedback = document.getElementById('feedback-message');
  
      popup.querySelectorAll('.category-box').forEach(categoryBox => {
        const category = categoryBox.getAttribute('data-category');
        const dropZone = categoryBox.querySelector('.drop-zone');
        const wordsInCategory = Array.from(dropZone.querySelectorAll('.word')).map(w => w.innerText.trim());
        const correctWords = correctAssignments[category];
  
        const hasAllCorrect = correctWords.every(w => wordsInCategory.includes(w));
        const hasNoIncorrect = wordsInCategory.every(w => correctWords.includes(w));
  
        if (!hasAllCorrect || !hasNoIncorrect) allCorrect = false;
      });
  
      if (allCorrect) {
        feedback.textContent = '✓ Richtig! Alle Begriffe sind korrekt zugeordnet.';
        feedback.className = 'feedback correct';
      } else {
        feedback.textContent = '❌ Einige Begriffe sind nicht korrekt zugeordnet. Bitte versuche es erneut.';
        feedback.className = 'feedback incorrect';
      }
    });
  
    // Weiter / Zurück
    nextBtn?.addEventListener('click', () => {
      document.getElementById('widerstand-page').classList.add('hidden');
      document.getElementById('akzeptanz-page').classList.remove('hidden');
      document.getElementById('popup-title').textContent = 'Akzeptanz fördern';
    });
    backBtn?.addEventListener('click', () => {
      document.getElementById('akzeptanz-page').classList.add('hidden');
      document.getElementById('widerstand-page').classList.remove('hidden');
      document.getElementById('popup-title').textContent = 'Widerstand im Change-Management';
    });
  
    // Close
    closeBtns.forEach(btn => btn.addEventListener('click', () => popup.classList.add('hidden')));
  
    // Kartenbeschreibung anzeigen (robust gegen fehlendes data-index)
    popup.querySelectorAll('.card').forEach((card, idx) => {
      const i = Number(card.dataset.index ?? idx);
      card.dataset.index = i;
      card.addEventListener('click', () => showCardText(i));
    });
  
    function showCardText(index) {
      const cardTexts = [
"Inklusive Entscheidungsfindung.", "Weiterbildungen und Feedback.", "klare Richtlinien und Standards.", "Gesprächrunden und Workshops.", "Infostände und Pilotprojekte."
      ];
      const i = Number(index);
      const inRange = Number.isInteger(i) && i >= 0 && i < cardTexts.length;
      const safeIndex = inRange ? i : 0;
      const display = document.getElementById('card-text-display');
      display.innerHTML = `<p><strong>Maßnahme ${safeIndex + 1}:</strong> ${cardTexts[safeIndex]}</p>`;
    }
  }
  
  // ❌ Keinen globalen Export mehr nötig (stell sicher, dass im HTML keine inline onclicks mehr sind)
  